// extracted by mini-css-extract-plugin
export default {"contents":"KG-z","sectionHeading":"LG-z"};